import React from "react";

interface Props {
    children: React.ReactNode;
}
const Layout = ({children}:Props) => {

    return(
        <>
            <div className="bg-[#e1eaec] grid justify-center">
                <div className="body-movil sm:w-[600px] md:w-[800px] lg:w-[1100px]">
                    <main>{children}</main>
                </div>
            </div>
        </>
    );
}
export default Layout;
